import { render, staticRenderFns } from "./ManageBeneficiary.vue?vue&type=template&id=3f1a692a&"
import script from "./ManageBeneficiary.vue?vue&type=script&lang=js&"
export * from "./ManageBeneficiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports